// Istanbul, Turkey
export const DEFAULT_CENTER = {
  lat: 41.0082376,
  lng: 28.9783589,
}
export const DEFAULT_ZOOM = 12
